module.exports = "<div class=\"wrapper wrapper-content animated fadeInUp\" style=margin-top:57px> <iframe-template path-url={{url}} css=100% key=index></iframe-template> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/index/view/normalIndex.html
// module id = XlZW
// module chunks = 0